"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const Row_1 = require("../components/Row");
const WeekTitle_1 = require("../components/WeekTitle");
const consts_1 = require("../consts");
const useSchedule_1 = require("../useSchedule");
const HEADER_DESIGNS = {
    normal: {
        text: constants_1.Color.DARK_GREY,
        highlight: constants_1.Color.BLUE,
        highlightText: constants_1.Color.WHITE,
    },
    holiday: {
        text: constants_1.Color.RED,
        highlight: constants_1.Color.RED,
        highlightText: constants_1.Color.WHITE,
    },
};
const Head = styled_1.default.thead({
    userSelect: 'none',
    position: 'sticky',
    top: 0,
    zIndex: consts_1.composableZIndex.head,
    height: consts_1.HEADER_HEIGHT,
});
const HeadCell = styled_1.default.th(({ isTitle, isScrolled, isSelectable, isSelected, isMonthZoom, design }) => ({
    backgroundColor: constants_1.Color.WHITE,
    color: HEADER_DESIGNS[design].text,
    padding: 0,
    textAlign: 'center',
    fontWeight: constants_1.theme.font.weight.regular,
    borderRight: isScrolled ? `1px solid ${constants_1.Color.GREY}` : undefined,
    position: isTitle ? 'sticky' : 'relative',
    left: isTitle ? 0 : 'auto',
    zIndex: isTitle
        ? consts_1.composableZIndex.headCellTitle
        : consts_1.composableZIndex.headCell,
    '.checkbox': {
        visibility: isSelected ? 'visible' : 'hidden',
        position: isMonthZoom ? 'absolute' : 'relative',
    },
    ':hover': isSelectable
        ? {
            '.checkbox': {
                visibility: 'visible',
            },
            span: isMonthZoom
                ? {
                    visibility: 'hidden',
                }
                : undefined,
        }
        : undefined,
    span: isMonthZoom && isSelected ? { visibility: 'hidden' } : undefined,
}));
const TitleHighlight = styled_1.default.span(({ design }) => ({
    padding: constants_1.theme.spacing[1],
    paddingLeft: constants_1.theme.spacing[2],
    paddingRight: constants_1.theme.spacing[2],
    borderRadius: constants_1.theme.border.radius.rounded,
    backgroundColor: HEADER_DESIGNS[design].highlight,
    color: HEADER_DESIGNS[design].highlightText,
}));
const HeadBorder = styled_1.default.th({
    height: 1,
    padding: 0,
    backgroundColor: constants_1.Color.MEDIUM_GREY,
});
const Header = (props) => {
    const { columnCount, zoom, days, currentWeek, isScrolled } = (0, useSchedule_1.useSchedule)();
    const { isDaySelected, toggleSelected, enableSelectDays } = (0, useSchedule_1.useSelectedDays)();
    const isMonthZoom = zoom === 'month';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("colgroup", { children: [(0, jsx_runtime_1.jsx)("col", {}), days.map((column) => ((0, jsx_runtime_1.jsx)("col", {}, column.dateISO)))] }), (0, jsx_runtime_1.jsxs)(Head, { children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, { children: [(0, jsx_runtime_1.jsx)(HeadCell, { isTitle: true, isScrolled: isScrolled, design: "normal", children: props.title ??
                                    (currentWeek ? (0, jsx_runtime_1.jsx)(WeekTitle_1.WeekTitle, { week: currentWeek.number }) : null) }), days.map((column) => {
                                const isSelected = isDaySelected(column.dateISO);
                                const columnTitle = isMonthZoom ? column.dateShort : column.dateLong;
                                const holiday = column.holiday;
                                const isSunday = column.date.isoWeekday() === 7;
                                const design = holiday?.isPublic || isSunday ? 'holiday' : 'normal';
                                return ((0, jsx_runtime_1.jsx)(HeadCell, { isSelectable: enableSelectDays, isSelected: isSelected, isMonthZoom: isMonthZoom, design: design, children: (0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 1, items: "center", styles: { justifyContent: 'center', position: 'relative' }, children: [column.isToday ? ((0, jsx_runtime_1.jsx)(TitleHighlight, { design: design, children: (0, jsx_runtime_1.jsx)(elements_1.FormattedText, { children: columnTitle }) })) : ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(elements_1.FormattedText, { children: columnTitle }) })), enableSelectDays && ((0, jsx_runtime_1.jsx)(elements_1.Div, { className: "checkbox", children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { size: "sm", checked: isSelected, onChange: () => toggleSelected(column.dateISO) }) }))] }) }, column.dateISO));
                            })] }), (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)(HeadBorder, { colSpan: columnCount }) })] })] }));
};
exports.Header = Header;
